import { Title } from './Header.styled';

export const Header = ({ children }) => {
  return <Title>{children}</Title>;
};
